import { ProtocolImageEntry } from '../../../shared/types/protocolImageEntry.ts';
import { Protocol } from '../../types/sharedTypeImpl.ts';
import { getChangedPaths } from './getChangedPaths.ts';
import { isSignificantChange } from './isSignificantChange.ts';


export function isReviewRequired(
    oldProtocol: Protocol | null,
    newProtocol: Protocol,
    pdfToUpload: Uint8Array | null,
    imagesToUpload: ProtocolImageEntry[],
): boolean {
    if (oldProtocol == null || pdfToUpload || imagesToUpload.length > 0) {
        return true;
    }

    const changedPaths = getChangedPaths(oldProtocol, newProtocol);
    const hasSignificantChange = changedPaths.some(change => isSignificantChange(change, oldProtocol, newProtocol));
    return hasSignificantChange;
}

